import './style.scss'
const errImg = require('./images/img.png')
export default {

  name: 'BaseImage',

  props: {
    src: String,
    thumbnail: String,
    viewerName: {
      type: String,
      default: 'viewer'
    },
    format: String,
    resize: [Array, String]
  },

  computed: {
    viewer () {
      let parent = this.$parent || this.$root
      let name = parent.$options.name
      while (name !== this.viewerName) {
        parent = parent.$parent
        if (!parent) break
        name = parent.$options.name
      }
      return parent
    },
    onload () {
      return this.viewer && this.viewer.updateViewer()
    },
    imgResize () {
      if (!this.resize) return ''
      if (typeof this.resize === 'string') return this.resize
      return this.resize.join(',')
    }
  },

  watch: {
    src: {
      handler (value) {
        const baseURL = process.env.VUE_APP_BASE_URL
        const src = (/^\//.test(value) ? (baseURL + value) : value)
        this._src = src
      },
      immediate: true
    },
    thumbnail: {
      handler (value) {
        if (value) {
          const baseURL = process.env.VUE_APP_BASE_URL
          const src = (/^\//.test(value) ? (baseURL + value) : value)
          this._thumbnail = src
        } else {
          if (this.src && this.src.includes('aliyuncs.com')) {
            // const format = this.format ? `image/format,${this.format}/` : ''
            // const resize = this.imgResize ? `resize,${this.imgResize}` : ''
            this._thumbnail = `${this.src}` // ?x-oss-process=${format}${resize}
          }
        }
      },
      immediate: true
    }
  },

  data () {
    return {
      _src: '',
      _thumbnail: ''
    }
  },

  render (h) {
    const attributes = {
      attrs: this.$attrs,
      on: this.$listeners
    }
    const onload = () => this.viewer && this.viewer.updateViewer()
    return <el-image
      src={ this._thumbnail || this._src }
      data-url={this._src}
      onLoad={onload}
      { ...attributes }
    >
      <span slot="placeholder" v-loading={true} class="base-image__placeholder">
        <img src={errImg} alt="error"/>
      </span>
      <div slot="error" class="base-image__error">
        <img src={errImg} alt="error"/>
      </div>
    </el-image>
  }
}
